"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _lodash = _interopRequireDefault(require("lodash"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/*
  TODO (Hubert, 2019A): Figure out how to import SCSS here
  TODO (Hubert, 2019B): Use CSS Modules!
*/
// import './Modal.scss';
var ModalContext = /*#__PURE__*/function (_React$Component) {
  _inherits(ModalContext, _React$Component);

  var _super = _createSuper(ModalContext);

  function ModalContext(props) {
    var _this;

    _classCallCheck(this, ModalContext);

    _this = _super.call(this, props);

    _this.popModal = function (result) {
      var topmost = null;

      if (_this.state.modals.length) {
        topmost = _this.state.modals[_this.state.modals.length - 1];
      }

      _this.setState({
        modals: _this.state.modals.slice(0, _this.state.modals.length - 1)
      });

      if (topmost.options && topmost.options.onPop) {
        topmost.options.onPop(result);
      }
    };

    _this.onPopModal = function (evt) {
      var topmost = _this.state.modals[_this.state.modals.length - 1];

      if (topmost.options && topmost.options.dismissable) {
        if (evt.target === evt.currentTarget) {
          evt.stopPropagation();

          _this.popModal(null);
        }
      }
    };

    _this.render = function () {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, _this.props.children, _lodash["default"].map(_this.state.modals, function (modal, idx) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: idx,
          className: "Modal-overlay",
          onClick: _this.onPopModal
        }, modal.modal);
      }));
    };

    _this.state = {
      modals: []
    };
    return _this;
  }

  _createClass(ModalContext, [{
    key: "getChildContext",
    value: function getChildContext() {
      var _this2 = this;

      return {
        displayModal: function displayModal(modal, options) {
          _this2.setState({
            modals: _this2.state.modals.concat({
              modal: modal,
              options: options
            })
          });
        },
        popModal: function popModal(result) {
          _this2.popModal(result);
        }
      };
    }
  }]);

  return ModalContext;
}(_react["default"].Component);

ModalContext.childContextTypes = {
  displayModal: _propTypes["default"].func,
  popModal: _propTypes["default"].func
};
;
var _default = ModalContext;
exports["default"] = _default;